var tool = {
    getBrowserType: function (timestamp) {
        var browser = navigator.appName;
        var version = navigator.appVersion;
        if (version.indexOf('AppleWebKit') >= 0) {
            return 'chrome';
        } else if (browser == "Microsoft Internet Explorer") {
            if (version.indexOf('MSIE 8.0') >= 0) {
                return 'ie8';
            } else if (version.indexOf('MSIE 9.0') >= 0) {
                return 'ie9';
            } else if (version.indexOf('MSIE 10.0') >= 0) {
                return 'ie10';
            } else {
                return 'ie';
            }
        } else if (browser == "Netscape") {
            if (version.indexOf('Trident') >= 0) {
                return 'ie11';
            }
            return 'firefox';
        } else {
            return 'other';
        }
    },
    newThanIe8: function () {
        var version = navigator.appVersion;
        if (version.indexOf('MSIE 8.0') >= 0) {
            return false;
        } else {
            return true;
        }
    },
    newThanIe9: function () {
        var version = navigator.appVersion;
        if (version.indexOf('MSIE 8.0') >= 0 || version.indexOf('MSIE 9.0') >= 0 ) {
            return false;
        } else {
            return true;
        }
    }
}

module.exports = tool;


// WEBPACK FOOTER //
// ./src/assets/util/browser.js